import StoniTenis from './StoniTenis'

const Odbojka = () => <StoniTenis calculatorType='Odbojka' />

export default Odbojka
